var _circle, _path, _circle2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialerPlanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.27259,
    cy: 3.63636,
    r: 3.63636,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.8182V14.0909H14.0909V11.8182C14.0909 11.8182 6.81818 5 0 11.8182Z",
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6366,
    cy: 11.8182,
    r: 5.86364,
    fill: "white",
    stroke: "#010028"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 9,
    x2: 13.5,
    y2: 12.6364,
    stroke: "#010028"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.9092,
    y1: 12.1364,
    x2: 17.5455,
    y2: 12.1364,
    stroke: "#010028"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialerPlanner);
export default __webpack_public_path__ + "static/media/dialerPlanner.cd2c2927.svg";
export { ForwardRef as ReactComponent };